import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupChartId, getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import { formatValue } from "../../utils/helpers";
import BannerRibbon from "../BannerRibbon";
import SimpleBarChart from "../charts/SimpleBarChart";
import DisaggregateMetricCard from "../DisaggregateMetricCard";
import MetricCard from "../MetricCard";

const EconomyMetrics = ({ indicators, categorizedData, geoDetails, tab, geoTag, selectionActive }: MetricPanelProps) => {   
    const econOrders = getMetricGroupOrderIds(tab);

    const sortedEconMetrics = econOrders.map((order: number[]) => 
        categorizedData.Economy
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Economy metrics:', sortedEconMetrics);

    const economy: DisaggregatedMetric[] = sortedEconMetrics[0];

    // const unemploy = indicators.find(metric => metric.id === 216);

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define median hh income for annual hhincome chart subtext
    const mhhInc = indicators.find(i => i.id === 217);
    const mhhIncVersion = mhhInc?.versions?.[0];

    const medhhIncomeVal = mhhIncVersion?.value ?? 0;
    const medhhIncomeUnit = mhhIncVersion?.unit ?? 'integer';

    return (
        <>
            <div className="mb-2">
                <BannerRibbon text="Economic Indicators" color="#225591"/>
            </div>   
            <p className="text-port-text mx-4 text-[10px] mb-4">Data updates published July 15, 2025. Data testing in progress.</p>
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                <div className="col-span-2 w-full my-4 pr-4">
                    {categorizedData.Economy.filter(metric => 
                        [getMetricGroupChartId(tab, "hhinc")].includes(metric.id) // Annual Household Income
                    ).map(metric => (
                        <DisaggregateMetricCard
                            key={metric.id}
                            id={metric.id}
                            metric={metric}
                            title={metric.name}
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showValue={false}
                        />
                    ))}
                    <div className="bg-[#F0F0F0]">
                        <SimpleBarChart indicators={indicators} title="Annual Household Income" tab="Economy" chartName="hhinc" height="h-56" barColor="#00A18A" reverseOrder={false} topFive={false}/>
                        <p className="text-port-text text-[11px] font-semibold text-center px-2 pb-4">Median Household Income: {formatValue(medhhIncomeVal, medhhIncomeUnit)}</p>
                    </div>
                </div>  
                
                {economy.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>
        </>
    );
}

export default EconomyMetrics;